import { DailyDataType } from "../types/Calendar";
import { convertPersianNumberToEnglish } from "./JavascriptHelpers";

export const dayInMilliseconds = 24 * 60 * 60 * 1000;

export function diffInDays(date1: Date, date2: Date) {
    return Math.abs(date1.getTime() - date2.getTime()) / dayInMilliseconds;
}

export function getDayInMonth(date = new Date()) {
    return new Intl.DateTimeFormat('fa-IR', {day: '2-digit'}).format(date)
} 

export function getMonth(date = new Date()) {
    return new Intl.DateTimeFormat('fa-IR', {month: 'short'}).format(date)
}

export function getDayIndex(date = new Date()) {
    const weekDays = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه']
    return weekDays.indexOf(new Intl.DateTimeFormat('fa-IR', {weekday: 'short'}).format(date)) 
}

export function ISOStringWithTimeZone(date = new Date()) {
    return new Intl.DateTimeFormat('en-US', {year: 'numeric'}).format(date)
            + '-' + new Intl.DateTimeFormat('en-US', {month: '2-digit'}).format(date) 
            + '-' + new Intl.DateTimeFormat('en-US', {day: '2-digit'}).format(date);
}

export async function traverseDaysInterval(startDay: Date, endDay: Date, today: Date, getKeyFromDate: (date: Date, traverseIndex: number) => string) {
    let currentDate = new Date(startDay);
    const data = {} as DailyDataType;

    return new Promise((resolve) => {
        let traverseIndex = 0;
        while (currentDate <= endDay) {
            const uniqeKey = getKeyFromDate(currentDate, traverseIndex)
        
            const currentData = data[uniqeKey] || [];
            currentData.push({
                jalali: formatDate(currentDate), 
                simplifiedJalali: formatDate(currentDate, true),
                ISO: ISOStringWithTimeZone(currentDate),
                dayIndex: getDayIndex(currentDate),
                dayInMonth: convertPersianNumberToEnglish(getDayInMonth(currentDate)) as number,
                isToday: currentDate.getTime() === today.getTime(),
                isCurrentMonth: getMonth(currentDate) === getMonth(today) 
            })
    
            data[uniqeKey] = currentData;
            currentDate.setDate(currentDate.getDate() + 1);
            traverseIndex++;
        }
        
        resolve(data);
    })
}


export function formatDate(date = new Date(), simplify = false) {
    try {        
        if (simplify)
            return convertPersianNumberToEnglish(new Intl.DateTimeFormat('fa-IR', {day: 'numeric'}).format(date)) + ' ' +
                new Intl.DateTimeFormat('fa-IR', {month: 'short'}).format(date) + ' '
        else
            return new Intl.DateTimeFormat('fa-IR', {weekday: 'short'}).format(date) + ' ' +
                new Intl.DateTimeFormat('fa-IR', {day: '2-digit'}).format(date) + ' ' +
                new Intl.DateTimeFormat('fa-IR', {month: 'short'}).format(date) + ' ' +
                new Intl.DateTimeFormat('fa-IR', {year: 'numeric'}).format(date)
    } catch (e) {
        return '';
    }
}

export function int_to_time(value: number | undefined, simplify: boolean = false) {
    if ((!value || isNaN(value)) && value !== 0)
        return ''

    const hour = Math.floor(value / 60).toString();
    const minute = (value % 60).toString();

    return (hour.length === 1 && !simplify ? '0' + hour : hour)
        + ":" +
        (minute.length === 1 && !simplify ? '0' + minute : minute);
}

export function extractTimeFromLabel(time: string) {
    const colonPosition = time?.indexOf(':') || 0;
    const hour = Number(time?.substring(0, colonPosition));
    const minute = Number(time?.substring(colonPosition + 1));
    const value = hour * 60 + minute;

    return {hour, minute, value}
}

export function twoDigitNumber(value: number) {
    const stringValue = value.toString();
    if (stringValue.length === 1)
        return '0' + stringValue;

    return stringValue;
}